import assessments from './models/AssessmentsHelper';
import availabilities from './models/AvailabilitiesHelper';
import coursePreregistrations from './models/CoursePreregistrationsHelper';
import courses from './models/CoursesHelper';
import followedCourses from './models/FollowedCoursesHelper';
import followedPath from './models/FollowedPathHelper';
import paths from './models/PathsHelper';
import projectSessions from './models/ProjectSessionsHelper';
import jurySessions from './models/JurySessionsHelper';
import signatories from './models/SignatoriesHelper';
import studentCredentials from './models/StudentCredentialsHelper';
import studentCredentialParchmentInformations from './models/StudentCredentialParchmentInformationsHelper';
import videoConferences from './models/VideoConferencesHelper';
import sessions from './models/SessionsHelper';
import studentCredentialPermissions from './models/StudentCredentialPermissionsHelper';
import sessionTermsPermissions from './models/SessionTermsPermissionsHelper';
import certifications from './models/CertificationsHelper';

export default {
  assessments,
  availabilities,
  certifications,
  coursePreregistrations,
  courses,
  followedCourses,
  followedPath,
  jurySessions,
  paths,
  projectSessions,
  sessions,
  signatories,
  studentCredentials,
  studentCredentialParchmentInformations,
  studentCredentialPermissions,
  sessionTermsPermissions,
  videoConferences,
};
